/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';

import { endpoints } from '../../../ia/util/config';

// check if key is a valid one by making an api call
export const validateKey = async (key: string): Promise<boolean> => {
  const response = await axios.get(
    `${endpoints.store}/integrations/segment/key`,
    {
      params: { key: key }
    }
  );
  return response?.data.valid;
};
